import type en from '../en/settings'
import type { Translation } from '../types'

/** Settings */
const settings: Translation<typeof en> = {
  "settings.mail.sent": "Test-E-Mail an {to} über {host} gesendet. Ihr eigener Mailserver ist ab jetzt in Verwendung.",
  "settings.mail.testFailed": "Die Test-E-Mail konnte nicht gesendet werden",
  "settings.mail.inUse": "In Verwendung: Ihr eigener Mailserver.",
  "settings.mail.notYet": "Noch nicht in Verwendung: Senden Sie eine Test-E-Mail, um Ihren eigenen Mailserver zu verwenden. Bis dahin läuft die Mail über den Mailserver der Plattform.",
  "settings.mail.sendTest": "Test-E-Mail senden",
  "settings.mail.testHint": "Geht an Ihre eigene Adresse, über die gespeicherten Einstellungen: Speichern Sie zuerst Ihre Änderungen.",
  "settings.saved": "Einstellungen gespeichert",
  "settings.saveFailed": "Die Einstellungen konnten nicht gespeichert werden",
  "settings.companySaved": "Unternehmensdaten gespeichert",
  "settings.companySaveFailed": "Die Unternehmensdaten konnten nicht gespeichert werden",
  "settings.licenseRenewed": "Lizenz erfolgreich verlängert!",
  "settings.licenseInvalid": "Ungültiger oder bereits verwendeter Lizenzcode",
  "settings.title": "Unternehmenseinstellungen",
  "settings.save": "Einstellungen speichern",
  "settings.companyInfo": "Unternehmensdaten",
  "settings.companyName": "Unternehmensname",
  "settings.customDomain": "Eigene Domain",
  "settings.customDomainHint": "Die Adresse, unter der man sich unter Ihrer eigenen Marke anmeldet. Richten Sie nach dem Speichern ihr DNS auf diese Plattform und weisen Sie mit einem TXT-Eintrag (hier angezeigt) nach, dass sie Ihnen gehört. Um das HTTPS-Zertifikat kümmert sich die Plattform selbst.",
  "settings.saveCompany": "Unternehmensdaten speichern",
  "settings.signIns": "Anmeldungen",
  "settings.sessionDays": "Maximale Sitzungsdauer (Tage)",
  "settings.sessionDaysHelp": "Danach meldet sich jeder im Unternehmen erneut an: 1 Tag bis 6 Monate (183 Tage), standardmäßig 7. Gezählt ab der Anmeldung; eine Änderung gilt auch für die laufenden Sitzungen.",
  "settings.idleMax": "Abmelden nach einer Zeit ohne Aktivität: höchstens",
  "settings.idleHelp": "Eine so lange nicht genutzte Sitzung wird abgemeldet (standardmäßig 8 Stunden). Jeder kann unter Mein Profil eine kürzere Zeit wählen.",
  "settings.idleOffWarning": "Damit können Personen einen der Kontoschutzmechanismen für dieses Unternehmen ausschalten: Eine auf einem unbeaufsichtigten Computer offen gelassene Sitzung bleibt dann angemeldet, bis sie ihre maximale Dauer erreicht.",
  "settings.idleOffQuestion": "Das Ausschalten erlauben?",
  "settings.idleOffLabel": "Personen das Abmelden nach Inaktivität für sich selbst ausschalten lassen",
  "settings.syncInterval": "Synchronisierungsintervall",
  "settings.dataPeriod": "Standardzeitraum für Daten",
  "settings.retention": "Datenaufbewahrung",
  "settings.automation": "Automatisierung und Warnungen",
  "settings.autoApply": "Standardwerte automatisch auf neue Standorte anwenden",
  "settings.autoApplySub": "Die Standardvorlage des Unternehmens automatisch anwenden, wenn sich ein Standort verbindet",
  "settings.emailAlerts": "E-Mail-Warnungen",
  "settings.emailAlertsSub": "Warn-E-Mails an die Unternehmensadministratoren senden, wenn Standorte offline gehen oder kritische Warnungen ausgelöst werden",
  "settings.webhookAlerts": "Webhook-Warnungen",
  "settings.webhookAlertsSub": "Warndaten per POST an die eingerichteten Webhook-URLs senden",
  "settings.smtp.title": "Eigene E-Mail / SMTP",
  "settings.smtp.intro": "Warnungen und E-Mails mit VPN-Konfiguration laufen über Ihren eigenen Mailserver, von Ihrer eigenen Adresse. Einladungen und Passwort-Zurücksetzungen kommen immer von der Plattform, sodass kein Mailserver außerhalb je einen Anmeldelink sieht. Leer lassen, um für alles die Plattform zu verwenden.",
  "settings.smtp.host": "SMTP-Host",
  "settings.smtp.userPlaceholder": "sie@domain.de",
  "settings.smtp.keepPlaceholder": "(leer lassen zum Behalten)",
  "settings.smtp.passwordPlaceholder": "SMTP-Passwort",
  "settings.smtp.encrypted": "Mit AES-256 verschlüsselt – nie an den Browser zurückgegeben",
  "settings.smtp.fromEmail": "Absenderadresse",
  "settings.smtp.fromEmailPlaceholder": "hallo@ihrunternehmen.de",
  "settings.smtp.fromName": "Absendername",
  "settings.overview": "Unternehmensübersicht",
  "settings.slug": "Kurzname",
  "settings.created": "Erstellt",
  "settings.brandingText": "Passen Sie das Erscheinungsbild Ihrer Plattform an: Farben, Logo, App-Name, Schriftarten und eigenes CSS.",
  "settings.openBranding": "Branding-Editor öffnen →",
  "settings.license": "Lizenz",
  "settings.expires": "Läuft ab",
  "settings.maxSites": "Max. Standorte",
  "settings.maxUsers": "Max. Benutzer",
  "settings.renewLicense": "Lizenz verlängern",
  "settings.licenseCode": "Lizenzcode",
  "settings.renew": "Verlängern",
  "settings.more": "Weitere Einstellungen",
  "settings.link.branding": "Branding und Erscheinungsbild",
  "settings.link.vpn": "VPN-Konfiguration",
  "settings.link.users": "Benutzer und Rollen",
  "settings.dns.ok": "Vorhanden",
  "settings.dns.missing": "Fehlt",
  "settings.dns.update": "Muss geändert werden",
  "settings.dns.unknown": "Konnte nicht geprüft werden",
  "settings.dns.title": "DNS-Einträge für Mail von {domain}",
  "settings.dns.freeMail": "{domain} gehört einem Mailanbieter: Nur dieser Anbieter kann dort Einträge hinzufügen, daher könnten Empfänger diese Mail als Spam behandeln. Verwenden Sie eine Adresse Ihrer eigenen Domain.",
  "settings.dns.addRecords": "Fügen Sie diese TXT-Einträge beim DNS-Anbieter von {domain} hinzu, damit empfangende Mailserver die Mail annehmen, statt sie als Spam zu markieren.",
  "settings.dns.copyName": "Namen des {type}-Eintrags kopieren",
  "settings.dns.copyValue": "Wert des {type}-Eintrags kopieren",
  "settings.dns.now": "Jetzt:",
  "settings.checkNow": "Jetzt prüfen",
  "settings.domain.proven": "Domain nachgewiesen",
  "settings.domain.serves": "{domain} liefert jetzt Ihr Dashboard aus.",
  "settings.domain.notFound": "Noch nicht gefunden",
  "settings.domain.dnsSlow": "DNS-Änderungen können eine Weile dauern – versuchen Sie es in ein paar Minuten erneut.",
  "settings.domain.checkFailed": "Prüfung fehlgeschlagen",
  "settings.domain.ownershipProven": "Inhaberschaft nachgewiesen",
  "settings.domain.ownershipNotYet": "Inhaberschaft noch nicht nachgewiesen",
  "settings.domain.dnsHere": "DNS zeigt hierher",
  "settings.domain.dnsNotYet": "DNS zeigt noch nicht hierher",
  "settings.domain.addTxt": "Fügen Sie diesen TXT-Eintrag bei Ihrem DNS-Anbieter hinzu. Bis er gefunden wird, zeigt {domain} eine Seite „wird eingerichtet“",
  "settings.domain.releaseBefore": "; wird er bis ",
  "settings.domain.releaseAfter": " nicht gefunden, wird die Domain von Ihrem Unternehmen freigegeben",
  "settings.domain.copyName": "Namen des Eintrags kopieren",
  "settings.domain.copyValue": "Wert des Eintrags kopieren",
  "settings.checked": " · geprüft {when}",
  "settings.domain.pointA": "Richten Sie außerdem einen A-Eintrag für {domain} auf {ip}.",
  "settings.domain.thisServer": "diesen Server",
  "settings.sso.saved": "Single Sign-On gespeichert",
  "settings.sso.intro": "Personen melden sich über Ihren eigenen Identitätsanbieter an (OpenID Connect: Microsoft Entra ID, Google Workspace, Okta, Keycloak und andere). Dessen Mehr-Faktor-Anmeldung ersetzt unsere. Registrieren Sie diese Rücksprungadressen für die Anmeldung beim Anbieter:",
  "settings.sso.copy": "{url} kopieren",
  "settings.sso.issuer": "Aussteller",
  "settings.sso.clientId": "Client-ID",
  "settings.sso.clientSecret": "Client-Secret",
  "settings.sso.secretStored": "Gespeichert – geben Sie ein neues ein, um es zu ersetzen",
  "settings.sso.on": "Single Sign-On ist eingeschaltet",
  "settings.sso.autoJoin": "Personen der nachgewiesenen Domains treten dem Unternehmen bei ihrer ersten Anmeldung bei",
  "settings.sso.withRole": "Mit der Rolle",
  "settings.sso.noRole": "Keine Rolle (nur, was jeder sehen darf)",
  "settings.sso.require": "Single Sign-On vorschreiben: keine Anmeldung mit Passwort für Personen der nachgewiesenen Domains",
  "settings.sso.breakGlassNote": "Notfall-Administratoren (unten) behalten ihr Passwort und ihre Zwei-Faktor-Anmeldung, für den Fall, dass der Identitätsanbieter nicht erreichbar ist.",
  "settings.sso.save": "Single Sign-On speichern",
  "settings.sso.domains": "Domains",
  "settings.sso.domainsIntro": "Weisen Sie eine Domain mit einem TXT-Eintrag nach: Ihre Adressen melden sich dann ohne Passwort an (und verknüpfen sich)",
  "settings.sso.domainsUntil": " – bis eine nachgewiesen ist, können nur Personen Single Sign-On verwenden, die sich über ihr Profil verknüpft haben",
  "settings.sso.proven": "Nachgewiesen",
  "settings.sso.notProven": "Noch nicht nachgewiesen",
  "settings.sso.removeConfirm": "{domain} entfernen? Ihre Personen können sich dann erst mit Single Sign-On anmelden, nachdem sie es selbst verknüpft haben.",
  "settings.sso.domainRemoved": "Domain entfernt",
  "settings.sso.copyName": "Namen des Eintrags für {domain} kopieren",
  "settings.sso.copyValue": "Wert des Eintrags für {domain} kopieren",
  "settings.sso.domainAdded": "Domain hinzugefügt",
  "settings.sso.domainToAdd": "Hinzuzufügende Domain",
  "settings.sso.addDomain": "Domain hinzufügen",
  "settings.sso.breakGlass": "Notfall-Administratoren",
  "settings.apikeys.revoked": "API-Schlüssel widerrufen",
  "settings.apikeys.revokeFailed": "Der Schlüssel konnte nicht widerrufen werden",
  "settings.apikeys.copied": "In die Zwischenablage kopiert",
  "settings.apikeys.title": "API-Schlüssel",
  "settings.apikeys.subtitle": "Zugriff auf Ihr Konto für Skripte und andere Systeme",
  "settings.apikeys.create": "API-Schlüssel erstellen",
  "settings.apikeys.createdTitle": "API-Schlüssel erstellt – kopieren Sie ihn jetzt",
  "settings.apikeys.createdText": "Der vollständige Schlüssel wird nur jetzt angezeigt. Bewahren Sie ihn sicher auf.",
  "settings.apikeys.hide": "Schlüssel verbergen",
  "settings.apikeys.show": "Schlüssel anzeigen",
  "settings.apikeys.dismiss": "Ich habe ihn gespeichert – schließen",
  "settings.apikeys.prefix": "Präfix",
  "settings.apikeys.permissions": "Berechtigungen",
  "settings.apikeys.lastUsed": "Zuletzt verwendet",
  "settings.apikeys.expires": "Läuft ab",
  "settings.apikeys.created": "Erstellt",
  "settings.apikeys.empty": "Noch keine API-Schlüssel",
  "settings.apikeys.revokedBadge": "Widerrufen",
  "settings.apikeys.none": "Keine",
  "settings.apikeys.never": "Nie",
  "settings.apikeys.revokeConfirm": "„{name}“ widerrufen? Das kann nicht rückgängig gemacht werden.",
  "settings.apikeys.revoke": "Schlüssel widerrufen",
  "settings.apikeys.revokeNamed": "{name} widerrufen",
  "settings.apikeys.nameRequired": "Ein Name ist erforderlich",
  "settings.apikeys.createFailed": "Der Schlüssel konnte nicht erstellt werden",
  "settings.apikeys.keyName": "Name des Schlüssels *",
  "settings.apikeys.keyNamePlaceholder": "z. B. CI/CD-Pipeline, Monitoring-Skript",
  "settings.apikeys.days30": "30 Tage",
  "settings.apikeys.days90": "90 Tage",
  "settings.apikeys.year1": "1 Jahr",
  "settings.apikeys.permHint": "Wählen Sie die Berechtigungen dieses Schlüssels. Ein Schlüssel braucht mindestens eine.",
  "settings.apikeys.createKey": "Schlüssel erstellen",
  "settings.branding.resetDone": "Branding auf die Standardwerte zurückgesetzt",
  "settings.branding.resetFailed": "Zurücksetzen fehlgeschlagen",
  "settings.branding.saved": "Branding gespeichert",
  "settings.branding.saveFailed": "Das Branding konnte nicht gespeichert werden",
  "settings.branding.title": "Branding",
  "settings.branding.subtitle": "Das Erscheinungsbild des Dashboards für Ihr Team",
  "settings.branding.resetConfirm": "Das gesamte Branding auf die Velanox-Standardwerte zurücksetzen? Alle eigenen Farben, Schriften und Logos werden entfernt.",
  "settings.branding.reset": "Auf Standard zurücksetzen",
  "settings.branding.save": "Branding speichern",
  "settings.branding.identity": "Identität",
  "settings.branding.appName": "App-Name",
  "settings.branding.logoUrl": "Logo-URL",
  "settings.branding.faviconUrl": "Favicon-URL",
  "settings.branding.loginBanner": "Bannerbild der Anmeldung",
  "settings.branding.colors": "Farben",
  "settings.branding.color.primaryColor": "Primär",
  "settings.branding.color.secondaryColor": "Sekundär",
  "settings.branding.color.accentColor": "Akzent",
  "settings.branding.color.backgroundColor": "Hintergrund",
  "settings.branding.color.sidebarColor": "Seitenleiste",
  "settings.branding.color.textColor": "Text",
  "settings.branding.colourOf": "Farbe {name}",
  "settings.branding.colourCode": "Farbcode {name}",
  "settings.branding.themeDefault": "Standard des Themas",
  "settings.branding.typography": "Typografie und Form",
  "settings.branding.font": "Schriftart",
  "settings.branding.fontDefault": "Plattform-Standard (Geist)",
  "settings.branding.radius": "Eckenradius",
  "settings.branding.radiusDefault": "Plattform-Standard",
  "settings.branding.radius.0": "Kantig (0px)",
  "settings.branding.radius.4": "Dezent (4px)",
  "settings.branding.radius.8": "Weich (8px)",
  "settings.branding.radius.12": "Abgerundet (12px)",
  "settings.branding.radius.16": "Stark abgerundet (16px)",
  "settings.branding.customCss": "Eigenes CSS",
  "settings.branding.customCssHint": "Erweitert: CSS, das jeder Seite hinzugefügt wird. Höchstens 50.000 Zeichen.",
  "settings.branding.cssPlaceholder": "/* Eigenes CSS */",
  "settings.branding.preview": "Live-Vorschau",
  "settings.branding.applyPreview": "Vorschau anwenden",
  "settings.branding.sampleBadge": "Beispiel-Badge",
  "settings.branding.previewHint": "Wählen Sie „Vorschau anwenden“, um die Änderungen live in der Seitenleiste zu sehen",
  "settings.messages.part.emailSubject": "Betreff der E-Mail",
  "settings.messages.part.emailBody": "Text der E-Mail",
  "settings.messages.part.whatsappBody": "WhatsApp-Text",
  "settings.messages.part.rcsBody": "RCS-Text",
  "settings.messages.wa.approved": "Von WhatsApp genehmigt: Ihr Text wird gesendet",
  "settings.messages.wa.rejected": "Von WhatsApp abgelehnt. Der Standardtext wird gesendet.",
  "settings.messages.wa.rejectedWhy": "Von WhatsApp abgelehnt: {reason}. Der Standardtext wird gesendet.",
  "settings.messages.wa.failed": "Noch nicht eingereicht ({reason}). Alle 30 Minuten neu versucht; bis dahin wird der Standardtext gesendet.",
  "settings.messages.wa.failedPlain": "Noch nicht eingereicht. Alle 30 Minuten neu versucht; bis dahin wird der Standardtext gesendet.",
  "settings.messages.wa.paused": "Von WhatsApp pausiert. Der Standardtext wird gesendet.",
  "settings.messages.wa.disabled": "Von WhatsApp deaktiviert. Der Standardtext wird gesendet.",
  "settings.messages.wa.pending": "Wartet auf die Genehmigung durch WhatsApp (meist innerhalb eines Tages). Bis dahin wird der Standardtext gesendet.",
  "settings.messages.notChanged": "Nicht geändert",
  "settings.messages.notSaved": "Nicht gespeichert",
  "settings.messages.tryAgain": "Versuchen Sie es gleich noch einmal.",
  "settings.messages.title": "Nachrichten",
  "settings.messages.subtitle": "Was Ihre Leute per {channels} erhalten. Ändern Sie den Wortlaut oder schalten Sie eine Nachricht aus.",
  "settings.messages.channel.email": "E-Mail",
  "settings.messages.channels2": "{a} und {b}",
  "settings.messages.channels3": "{a}, {b} und {c}",
  "settings.messages.defaultsPending": "Ihr eigenes WhatsApp-Konto hat die Standardtexte noch nicht genehmigt: Bis dahin werden WhatsApp-Nachrichten als einfacher Text gesendet, der nur innerhalb von 24 Stunden nach der letzten Nachricht des Empfängers ankommt.",
  "settings.messages.variablesInfo": "Wörter in doppelten geschweiften Klammern, wie {example}, werden beim Senden ausgefüllt. Links kommen nur aus den Link-Variablen. Einladungen und Passwort-Zurücksetzungen betreffen die Sicherheit und werden daher immer gesendet.",
  "settings.messages.noLicence": "Ihre Lizenz umfasst das Ändern von Nachrichten nicht. Sie können eine Nachricht aber auf den Standard zurücksetzen.",
  "settings.messages.sentEmail": "Per E-Mail gesendet",
  "settings.messages.sentWhatsapp": "Per WhatsApp gesendet",
  "settings.messages.sentRcs": "Per RCS gesendet",
  "settings.messages.ownWording": "Eigener Wortlaut",
  "settings.messages.alwaysSent": "Immer gesendet",
  "settings.messages.on": "An",
  "settings.messages.off": "Aus",
  "settings.messages.sendNamed": "„{label}“ senden",
  "settings.messages.resetConfirm": "„{label}“ auf den Standardwortlaut zurücksetzen?",
  "settings.messages.resetDone": "Auf Standard zurückgesetzt",
  "settings.messages.ownMeta": "Ihr eigenes WhatsApp läuft über Meta: Die Texte sind die Vorlagen, die unter Unternehmenseinstellungen → WhatsApp genannt sind.",
  "settings.messages.twilioOnly": "WhatsApp-Texte lassen sich ändern, wenn die Plattform WhatsApp über Twilio sendet.",
  "settings.messages.waRules": "Ein Absatz, Wörter vor der ersten und nach der letzten Variablen, nie zwei Variablen direkt nebeneinander. Ein geänderter Text muss von WhatsApp genehmigt werden, bevor er verwendet wird.",
  "settings.messages.rcsNote": "Kommt in der Nachrichten-App des Telefons an. Sofort verwendet: RCS-Texte brauchen keine Genehmigung.",
  "settings.messages.insertVariable": "Eine Variable einfügen",
  "settings.messages.example": "Beispiel: {value}",
  "settings.messages.required": "* muss im Text der E-Mail bleiben",
  "settings.messages.save": "Speichern",
  "settings.messages.backToDefault": "Auf Standard zurücksetzen",
  "settings.messages.previewRegion": "Vorschau mit Beispielwerten",
  "settings.messages.preview": "Vorschau",
  "settings.vpn.downloadFailed": "Download fehlgeschlagen",
  "settings.vpn.mayBeCreating": "Die VPN-Datei wird möglicherweise noch erstellt.",
  "settings.vpn.creating": "VPN-Konto angefordert",
  "settings.vpn.creatingText": "Ihr VPN-Konto wird erstellt. Aktualisieren Sie in 30 Sekunden.",
  "settings.vpn.createFailed": "Das VPN-Konto konnte nicht erstellt werden",
  "settings.vpn.contactAdmin": "Wenden Sie sich an Ihren Administrator.",
  "settings.vpn.regenerated": "Neue VPN-Datei erstellt",
  "settings.vpn.regeneratedText": "Laden Sie Ihre neue Datei unten herunter.",
  "settings.vpn.regenerateFailed": "Es konnte keine neue VPN-Datei erstellt werden",
  "settings.vpn.memberConfirm": "Eine neue VPN-Datei für „{name}“ erstellen? Die aktuelle funktioniert dann nicht mehr.",
  "settings.vpn.memberDone": "VPN-Konto angefordert",
  "settings.vpn.memberDoneText": "Für {name} wird eine neue VPN-Datei erstellt.",
  "settings.vpn.suspendConfirm": "Das VPN von „{name}“ sperren?",
  "settings.vpn.enableConfirm": "Das VPN von „{name}“ wieder einschalten?",
  "settings.vpn.suspended": "VPN gesperrt",
  "settings.vpn.enabled": "VPN eingeschaltet",
  "settings.vpn.notChanged": "Nicht geändert",
  "settings.vpn.siteRegenerated": "Neue VPN-Datei für den Standort erstellt",
  "settings.vpn.subtitle": "OpenVPN: ein eigenes Netz für jedes Unternehmen",
  "settings.vpn.mine": "Mein VPN-Konto",
  "settings.vpn.lastSeen": "Zuletzt gesehen",
  "settings.vpn.download": ".ovpn herunterladen",
  "settings.vpn.regenerateMineConfirm": "Eine neue VPN-Datei erstellen? Ihre aktuelle .ovpn-Datei funktioniert dann nicht mehr.",
  "settings.vpn.regenerateHint": "Neue Datei: wenn die aktuelle verloren ist oder von anderen gesehen worden sein kann",
  "settings.vpn.regenerate": "Zertifikat erneuern",
  "settings.vpn.suspendedMine": "Ihr VPN-Konto ist gesperrt. Wenden Sie sich an Ihren Administrator.",
  "settings.vpn.noAccount": "Noch kein VPN-Konto.",
  "settings.vpn.createMine": "Mein VPN-Konto erstellen",
  "settings.vpn.network": "VPN-Netz des Unternehmens",
  "settings.vpn.usersNet": "Netz der Benutzer",
  "settings.vpn.sitesNet": "Netz der Standorte",
  "settings.vpn.isolation": "Benutzer erreichen jeden Standort des Unternehmens. Standorte erreichen einander nicht.",
  "settings.vpn.networkPending": "Das VPN-Netz wird eingerichtet…",
  "settings.vpn.all": "Alle VPN-Konten",
  "settings.vpn.count": { one: "{count} Konto", other: "{count} Konten" },
  "settings.vpn.account": "Konto",
  "settings.vpn.type": "Typ",
  "settings.vpn.type.USER": "Person",
  "settings.vpn.type.SITE": "Standort",
  "settings.vpn.empty": "Noch keine VPN-Konten",
  "settings.vpn.downloadSite": "VPN-Datei des Standorts herunterladen",
  "settings.vpn.siteConfirm": "Eine neue VPN-Datei für „{name}“ erstellen? Die aktuelle funktioniert dann nicht mehr.",
  "settings.vpn.suspend": "VPN sperren",
  "settings.vpn.enable": "VPN einschalten",
  "settings.vpn.createFor": "VPN-Konto erstellen",
  "settings.vpn.setup": "Einrichtungsanleitung",
  "settings.vpn.tab.personal": "Eigenes Gerät",
  "settings.vpn.tab.unifi": "UniFi OS (Router des Standorts)",
  "settings.vpn.pc.1": "Laden Sie OpenVPN Connect von https://openvpn.net/client/ herunter",
  "settings.vpn.pc.2": "Wählen Sie + und dann „Upload File“",
  "settings.vpn.pc.3": "Wählen Sie Ihre .ovpn-Datei",
  "settings.vpn.pc.4": "Wählen Sie Connect – kein Benutzername oder Passwort nötig",
  "settings.vpn.pc.note": "OpenVPN Connect 3.x ist erforderlich. Die ältere OpenVPN GUI funktioniert ebenfalls.",
  "settings.vpn.linux.1": "Installieren: sudo apt install openvpn (oder das Entsprechende für Ihre Distribution)",
  "settings.vpn.linux.2": "Verbinden: sudo openvpn --config ihr-name.ovpn",
  "settings.vpn.linux.3": "Oder nutzen Sie NetworkManager: Importieren Sie die .ovpn-Datei über das Netzwerkmenü",
  "settings.vpn.ios.1": "Installieren Sie „OpenVPN Connect“ aus dem App Store",
  "settings.vpn.ios.2": "Senden Sie die .ovpn-Datei per AirDrop oder E-Mail an Ihr Gerät",
  "settings.vpn.ios.3": "Wählen Sie „Mit OpenVPN Connect öffnen“, wenn Sie gefragt werden",
  "settings.vpn.ios.4": "Wählen Sie Add und dann Connect",
  "settings.vpn.android.1": "Installieren Sie „OpenVPN Connect“ aus dem Play Store",
  "settings.vpn.android.2": "Teilen Sie die .ovpn-Datei mit OpenVPN Connect",
  "settings.vpn.android.3": "Wählen Sie Import und dann Connect",
  "settings.vpn.security": "Sicherheit:",
  "settings.vpn.securityText": "Halten Sie Ihre .ovpn-Datei vertraulich: Sie ist Ihr persönlicher Zugang. Ist sie verloren oder könnte sie von anderen gesehen worden sein, erstellen Sie oben eine neue Datei; die alte funktioniert dann nicht mehr.",
  "settings.webhooks.event.site.offline": "Standort offline",
  "settings.webhooks.event.site.online": "Standort wieder online",
  "settings.webhooks.event.alert.critical": "Kritische Meldungen",
  "settings.webhooks.event.alert.error": "Fehlermeldungen",
  "settings.webhooks.event.alert.warning": "Warnungen",
  "settings.webhooks.event.alert.info": "Informationen",
  "settings.webhooks.event.license.expiring": "Lizenz läuft ab",
  "settings.webhooks.deleted": "Webhook gelöscht",
  "settings.webhooks.deleteFailed": "Der Webhook konnte nicht gelöscht werden",
  "settings.webhooks.toggleFailed": "Der Webhook konnte nicht umgeschaltet werden",
  "settings.webhooks.testDelivered": "Test zugestellt",
  "settings.webhooks.answered": "Ihr Endpunkt hat mit {code} geantwortet.",
  "settings.webhooks.testFailed": "Test fehlgeschlagen",
  "settings.webhooks.noResponse": "Keine Antwort",
  "settings.webhooks.unreachable": "Prüfen Sie, ob die Webhook-URL erreichbar ist und mit einem 2xx-Status antwortet.",
  "settings.webhooks.title": "Webhooks",
  "settings.webhooks.subtitle": "Ereignisse, die sofort an Ihre eigenen Systeme gesendet werden, per HTTP POST",
  "settings.webhooks.add": "Webhook hinzufügen",
  "settings.webhooks.eventsLabel": "Ereignisse:",
  "settings.webhooks.info": "Jeder Webhook erhält die für ihn gewählten Ereignisse (alle, wenn keine gewählt sind). Die Nutzdaten werden mit HMAC-SHA256 und Ihrem Webhook-Geheimnis signiert.",
  "settings.webhooks.events": "Ereignisse",
  "settings.webhooks.updated": "Zuletzt aktualisiert",
  "settings.webhooks.empty": "Noch keine Webhooks",
  "settings.webhooks.allEvents": "Alle Ereignisse",
  "settings.webhooks.disable": "Ausschalten",
  "settings.webhooks.enable": "Einschalten",
  "settings.webhooks.sendTest": "Testereignis senden",
  "settings.webhooks.edit": "Bearbeiten",
  "settings.webhooks.deleteConfirm": "Webhook „{name}“ löschen?",
  "settings.webhooks.nameRequired": "Ein Name ist erforderlich",
  "settings.webhooks.urlRequired": "Eine URL ist erforderlich",
  "settings.webhooks.saveFailed": "Der Webhook konnte nicht gespeichert werden",
  "settings.webhooks.editTitle": "Webhook bearbeiten",
  "settings.webhooks.name": "Name *",
  "settings.webhooks.namePlaceholder": "Mein Webhook",
  "settings.webhooks.secret": "Geheimnis",
  "settings.webhooks.secretKeep": "(leer lassen, um das aktuelle zu behalten)",
  "settings.webhooks.secretRecommended": "(empfohlen)",
  "settings.webhooks.secretPlaceholder": "Optionales Geheimnis für die HMAC-Signatur",
  "settings.webhooks.signed": "Wenn gesetzt, wird jede Nutzlast in diesem Header signiert:",
  "settings.webhooks.noneChosen": "(keine gewählt: alle)",
  "settings.webhooks.saveChanges": "Änderungen speichern",
  "settings.messages.who": "Wer erhält diesen Text",
  "settings.messages.who.everyone": "Alle, unabhängig von ihrer Sprache",
  "settings.messages.who.perLanguage": "Je Sprache — die anderen erhalten den Standardtext in ihrer Sprache",
  "settings.messages.language": "Sprache",
  "settings.messages.hasOwnText": "hat einen eigenen Text",
  "settings.messages.everyoneHint": "Einmal geschrieben und unverändert an alle gesendet. Teile, die Sie nicht ändern, folgen der Sprache jeder Person.",
  "settings.messages.languageHint": "Wer {language} liest, erhält diesen Text; bis Sie ihn ändern, steht hier der Standardtext auf {language}.",
  "settings.messages.removeLanguage": "Den Text auf {language} entfernen",
  "settings.messages.removeLanguageConfirm": "Den Text auf {language} von „{label}“ entfernen? Wer {language} liest, erhält dann den Standardtext.",
  "settings.messages.removed": "Text entfernt",
  "settings.tabs": "Bereiche der Einstellungen",
  "settings.tab.general": "Allgemein",
  "settings.tab.security": "Sicherheit",
  "settings.tab.monitoring": "Überwachung und Meldungen",
  "settings.tab.messaging": "Nachrichten",
  "settings.tab.licence": "Lizenz",
  "settings.unsaved": "nicht gespeicherte Änderungen",
  "settings.languageTime": "Sprache und Zeitzone",
  "settings.messaging.none": "Ihre Lizenz enthält keinen eigenen Mailserver, kein WhatsApp und kein RCS: Nachrichten gehen über die Plattform.",
  "settings.logo.title": "Logo",
  "settings.logo.alt": "Logo von {name}",
  "settings.logo.hint": "Zeigt das Unternehmen dort, wo Sie es nach der Anmeldung auswählen, und in Listen. Jedes Bild (PNG, JPEG, WebP, GIF, SVG, AVIF…), bis 10 MB; es wird auf 256 × 256 verkleinert.",
  "settings.logo.choose": "Bild auswählen",
  "settings.logo.change": "Bild ändern",
  "settings.logo.remove": "Logo entfernen",
  "settings.logo.removeConfirm": "Das Logo von {name} entfernen?",
  "settings.logo.saved": "Logo gespeichert",
  "settings.logo.removed": "Logo entfernt",
  "settings.logo.notSaved": "Logo nicht gespeichert",
  "settings.logo.wrongType": "Wählen Sie eine Bilddatei",
  "settings.logo.tooLarge": "Das Bild ist größer als 10 MB",
  "settings.logo.unreadable": "Dieser Browser kann dieses Bild nicht öffnen: Speichern Sie es als PNG oder JPEG und versuchen Sie es erneut",
  "settings.banner.title": "Banner-Logo",
  "settings.banner.hint": "Wird in der Mitte der oberen Leiste statt des Firmennamens angezeigt. Ein breites Bild, jeder Art (PNG, JPEG, WebP, GIF, SVG, AVIF…), bis 10 MB.",
  "settings.banner.remove": "Banner-Logo entfernen",
  "settings.banner.removeConfirm": "Das Banner-Logo von {name} entfernen?",
  "settings.banner.saved": "Banner-Logo gespeichert",
  "settings.banner.removed": "Banner-Logo entfernt",
  "settings.banner.notSaved": "Banner-Logo nicht gespeichert",
  "settings.tab.rental": "Vermietung",
  "settings.tab.connections": "Verbindungen",
  "settings.connections.intro": "Die Controller, über die Ihre Standorte erreicht werden. Jede Verbindung wird beim Speichern geprüft; ein Geheimnis wird nie wieder angezeigt.",
  "settings.connections.none": "Noch keine Verbindungen: Fügen Sie eine über die Seite Standorte hinzu.",
  "settings.connections.saved": "Verbindung gespeichert",
  "settings.connections.saveFailed": "Verbindung konnte nicht gespeichert werden",
  "settings.connections.deleted": "Verbindung gelöscht",
  "settings.connections.deleteFailed": "Verbindung konnte nicht gelöscht werden",
  "settings.connections.sites": { one: "{count} Standort", other: "{count} Standorte" },
  "settings.connections.checked": "geprüft {when}",
  "settings.connections.waiting": "Wartet auf die VPN-Verbindung des Controllers: laden Sie die .ovpn herunter und starten Sie sie auf dem Rechner des Controllers.",
  "settings.connections.save": "Speichern",
  "settings.connections.addSites": "Standorte hinzufügen",
  "settings.connections.edit": "Bearbeiten",
  "settings.connections.deleteConfirm": "Die Verbindung {name} löschen?",
  "settings.connections.newCert": "Neues Zertifikat",
  "settings.connections.newCertDone": "Neues Zertifikat ausgestellt: laden Sie die .ovpn herunter und starten Sie sie auf dem Rechner des Controllers",
  "settings.connections.newCertFailed": "Neues Zertifikat konnte nicht ausgestellt werden",
  "settings.phonesStay": "Telefone dürfen angemeldet bleiben (die mobile App, geöffnet mit Face ID oder Fingerabdruck)",
  "settings.phonesStayHelp": "Das Inaktivitätslimit oben zählt auch die Zeit in der App; danach fragt das Telefon erneut nach Face ID.",
  "settings.phonesOffConfirm": "Ausschalten? Beim Speichern wird jedes Telefon des Unternehmens abgemeldet und fragt erneut nach dem Passwort.",
  "settings.messages.part.pushTitle": "Titel der Push-Mitteilung",
  "settings.messages.part.pushBody": "Text der Push-Mitteilung",
  "settings.messages.sentPush": "Als Push-Mitteilung gesendet (Telefon-App)",
  "settings.messages.pushNote": "Auf dem Sperrbildschirm des Telefons unter dem Namen der Velanox-App angezeigt; höchstens 100 und 500 Zeichen.",
  "settings.messages.pushPreview": "Velanox-App · Push-Mitteilung",
  "settings.simPins.title": "SIM-Karten",
  "settings.simPins.help": "Die Firmen-PIN für die SIMs in Teltonika-Routern und die SIMs mit eigener PIN. PINs erscheinen als Punkte; Anzeigen fragt nach Ihrem Passwort und wird protokolliert.",
  "settings.simPins.companyPin": "Firmen-PIN",
  "settings.simPins.notSet": "Nicht festgelegt",
  "settings.simPins.set": "Festlegen",
  "settings.simPins.save": "Speichern",
  "settings.simPins.newCompanyPin": "Neue Firmen-PIN (4 bis 8 Ziffern)",
  "settings.simPins.changeHelp": "SIMs, die bereits mit der aktuellen Firmen-PIN gesperrt sind, behalten sie als eigene PIN.",
  "settings.simPins.show": "Anzeigen",
  "settings.simPins.ownPins": "SIMs mit eigener PIN",
  "settings.simPins.noOwn": "Noch keine.",
  "settings.simPins.removeConfirm": "Die PIN der SIM {iccid} vergessen?",
  "settings.simPins.notShown": "Die PIN wurde nicht angezeigt",
  "settings.simPins.notSaved": "Nicht gespeichert",
  "settings.simPins.removeNoteConfirm": "Die Notiz der SIM {iccid} vergessen? Sie bleibt auf der Firmen-PIN.",
  "settings.pushFirst.title": "Zuerst Push",
  "settings.pushFirst.companyIntro": "Gilt für das eigene WhatsApp und RCS dieses Unternehmens.",
  "settings.pushFirst.on": "Push geht zuerst",
  "settings.pushFirst.onHelp": "Eine Meldung geht per Push an alle mit der App; WhatsApp oder RCS folgen nur, wenn sie innerhalb der Wartezeit nicht gesehen wurde.",
  "settings.pushFirst.wait": "Wartezeit vor WhatsApp oder RCS (Minuten)",
  "settings.pushFirst.waitRange": "1 bis 60 ganze Minuten",
  "settings.pushFirst.anyone": "WhatsApp und RCS auslassen, sobald jemand es gesehen hat",
  "settings.pushFirst.anyoneHelp": "Öffnet ein Kollege den Standort, zählt das für alle, die darüber benachrichtigt wurden.",
  "settings.pushFirst.save": "Speichern",
  "settings.backdrop.dark": "Hintergrund im dunklen Modus",
  "settings.backdrop.light": "Hintergrund im hellen Modus",
  "settings.backdrop.none": "Keiner",
  "settings.backdrop.default.dark": "Warmweiß",
  "settings.backdrop.default.light": "Dashboard-Dunkel",
  "settings.backdrop.own": "Eigene Farbe",
  "settings.backdrop.colour.dark": "Hintergrundfarbe im dunklen Modus",
  "settings.backdrop.colour.light": "Hintergrundfarbe im hellen Modus",
  "settings.backdrop.saved": "Hintergrund gespeichert",
  "settings.backdrop.notSaved": "Hintergrund nicht gespeichert",
  "settings.backdrop.help": "Für ein Bild, das in einem Modus verschwindet: ein heller Hintergrund hinter dunkler Schrift, ein dunkler hinter heller Schrift.",
}

export default settings
